import React from 'react';
import styled from 'styled-components';
import Button from 'components/Elements/Button/Button';
import ProgramAlert from './ProgramAlert';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const StartButton = styled(Button)`
  margin-top: 35px;
`;

interface IApplicationNotStartedProps {
  onStart: () => void;
  isLoading: boolean;
}
export default function ApplicationNotStarted(
  props: IApplicationNotStartedProps,
) {
  const { isLoading, onStart } = props;
  return (
    <Container>
      <ProgramAlert type="danger">
        <p>You have not started your application.</p>

        <p>Click the button bellow to start your application.</p>
      </ProgramAlert>

      <StartButton
        onClick={onStart}
        isLoading={isLoading}
        color="green"
        size="full"
      >
        <p>Start</p>
      </StartButton>
    </Container>
  );
}
